<template>
    <dtunes-modal :dialog="dialog" @openModal="dialog = true" @closeModal="dialog = false">
        <template v-slot:button auto> Terms</template>
        <template v-slot:content>
            <v-card class="pad-10">
                <v-card-title class="d-flex justify-center">
                    <p class="text-center">View Terms and Conditions</p>
                </v-card-title>
                <v-card-text class="pb-5">
                    <template>
                        <form>
                            <div>
                                <v-text-field v-model="singleTerm" label="Terms and Conditions"></v-text-field>
                            </div>


                            <div> <v-btn @click="uploadGiftcardTerm" class="float-end" auto variant="tonal">
                                    Add Terms
                                </v-btn>
                            </div>
                        </form>
                    </template>


             <div class="mt-15">
                <v-row v-for="(term, index) in terms" :key="term.id">
                    <v-col>
                        <v-row class=" mt-2" style="background-color: whitesmoke;">
                            <v-col cols="12" sm="8" md="10" style="color:black"><v-icon>mdi-stop</v-icon>  {{ term.name }} </v-col> 
                             <v-col cols="12" sm="2" md="1"> <v-icon style="color:red" @click="deleteGiftcardTerm(index)" >mdi-close</v-icon></v-col>
                            <v-col cols="12" sm="2" md="1"> <v-icon style="color:green" @click="editGiftcardTerm(index)" >mdi-pencil</v-icon></v-col>
                        </v-row>
                      
                       
                    </v-col>
                  </v-row>
             </div>
                   
                </v-card-text>
            </v-card>
        </template>
</dtunes-modal>
</template>

<script>

//   // ========== IMPORT COMPONENTS =============
import DtunesModal from "@/components/dtunes-modal.vue";

//   // ============ IMPORT SERVICES ===============
import { StoresService } from "@/services";

export default {
    props: {
        terms: {
            type: Array,

        },
        id: {
            type: String,
        }
    },
    data: () => ({
        singleTerm: '',
        name: '',
        rate: '',
        tmStamp: '',
        loading: false,
        dialog: false,

    }),
    components: {
        DtunesModal,
    },
    mounted() {
        //   this.loadGiftcards();
        //   this.loadCountries();
    },
    methods: {

        //============ METHOD TO UPLOAD GITCARD TERMS ======

        async uploadGiftcardTerm() {
           
            this.loading = true;

            let data = await StoresService.uploadTerms({ id: this.id, term: this.singleTerm });
            console.log('hope it works', data);
            this.singleTerm = '';
            this.terms.push(data);
            if (data) {
                alert(" terms added successfully");
            }
        },

        async deleteGiftcardTerm(id){
           const resp = confirm('you are deleting term: ' + this.terms[id].name);
           if(!resp) return;
            let data = await StoresService.deleteTerms(this.terms[id].id);
            console.log('hope it works', data);
            if (data) {
                alert(" terms deleted successfully");
                this.terms.splice(id, 1);
            }
        },
        async editGiftcardTerm(id){
            let inputValue = window.prompt('update the below term', this.terms[id].name);
            console.log(inputValue);
            this.terms[id].name = inputValue;
            let data = await StoresService.editTerm(this.terms[id]);
            console.log('hope it works', data);
            if (data) {
                alert(" term editted successfully");
              
            }
        }

       
    }
};
</script>